import React, {useState} from "react";
import {Form, Input, Button, Space, Modal, message, InputNumber} from 'antd';
import {MinusCircleOutlined, PlusOutlined} from '@ant-design/icons';
import TextArea from "antd/es/input/TextArea";
import Api from "../api";
import {useParams} from "react-router-dom";

const NewBingoChallenge = ({loadChallenges}) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const params = useParams();

    const showModal = () => {
        setIsModalVisible(true);
    };

    const onFinish = (values: any) => {
        Api.post(`/admin/v2/bingos/${params.id}/challenges`, values).then(res => {
            setIsModalVisible(false);
            loadChallenges()
            return message.success('Success! New challenge added!');
        }).catch(e => {
            return message.error(`${e.message}`);
        })
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    console.log(params);

    return (
        <>
            <Button className="add-translation-btn" type="primary" onClick={showModal}>
                <PlusOutlined/> Add new challenge
            </Button>

            <Modal title="Add new challenge"
                   visible={isModalVisible}
                   onCancel={handleCancel}
                   footer={null}
            >
                <Form
                    name="add-bingo-challenge"
                    labelCol={{span: 8}}
                    wrapperCol={{span: 16}}
                    onFinish={onFinish}
                    initialValues={{remember: true}}
                    autoComplete="off"
                >
                    <Form.Item
                        label="Name"
                        name="name"
                        rules={[{required: true, message: 'Please insert name'}]}>
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label="Description"
                        name="description"
                        rules={[{required: true, message: 'Please insert description'}]}>
                        <TextArea/>
                    </Form.Item>
                    <Form.Item
                        label="Icon"
                        name="icon"
                        >
                        <Input/>
                    </Form.Item>

                    <Form.Item wrapperCol={{offset: 8, span: 16}}>
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>

    );
};

export default NewBingoChallenge;